import React from "react";
import FusionCharts from "fusioncharts";
import TimeSeries from "fusioncharts/fusioncharts.timeseries";
import ReactFC from "react-fusioncharts";
import API from "../../apiService";
import moment from "moment";
ReactFC.fcRoot(FusionCharts, TimeSeries);

// const dataFetch = [
//     [
//         "2016-01-01",
//         110,
//         90, 10, 80
//     ],
//     [
//         "2016-01-02",
//         120, 90, 20, 88
//     ],
//     [
//         "2016-01-03",
//         110, 80, 30, 81
//     ],
//     [
//         "2016-01-04",
//         120, 100, 25, 80
//     ],
//     [
//         "2016-01-05",
//         110, 80, 21, 76
//     ]
// ];
const schemaFetch = [
  {
    name: "Time",
    type: "date",
    format: "%Y-%m-%d"
  },
  {
    name: "sistole",
    type: "number"
  },
  {
    name: "diastole",
    type: "number"
  },
  {
    name: "nadi",
    type: "number"
  },
  {
    name: "pernapasan",
    type: "number"
  },
  {
    name: "temperature",
    type: "number"
  }
];

const dataSource = {
  caption: {
    text: "Grafik Vital Sign"
  },
  subcaption: {
    text: "Rawat Jalan"
  },
  extensions: {
    customRangeSelector: {
      enabled: 0
    }
  },
  chart: {
    showlegend: 1,
    showtooltip: 1,
    multicanvas: false
  },
  yaxis: [
    {
      title: "Tekanan Darah",
      min: "50",
      max: "300",
      plot: [
        {
          value: {
            high: "sistole",
            low: "diastole"
          },
          type: "area-range",
          name: "Tekanan Darah",
          connectnulldata: true
        }
      ]
    },
    {
      plot: [
        {
          value: "nadi",
          connectnulldata: true
        }
      ],
      min: "30",
      max: "200",
      title: "Nadi"
    },
    {
      plot: [
        {
          value: "pernapasan",
          connectnulldata: true
        }
      ],
      min: "10",
      max: "100",
      title: "Pernapasan"
    },
    {
      plot: [
        {
          value: "temperature",
          connectnulldata: true
        }
      ],
      min: "20",
      max: "50",
      title: "temperature"
    }
  ]
};

export default class ChartViewer extends React.Component {
  constructor(props) {
    super(props);
    this.onFetchData = this.onFetchData.bind(this);
    this.state = {
      timeseriesDs: {
        type: "timeseries",
        renderAt: "container",
        width: "100%",
        height: "2000%",
        dataSource
      },
      dataFetch: [],
      data: []
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.histories !== this.props.histories) {
      this.setState({ data: this.props.histories.reverse() }, () => {
        this.onFetchData();
      });
    }
  }

  // getHistories = async () => {
  //   const res = await API.get("registration/history/" + this.props.id);
  //   if (res.code === 200) {
  //     this.setState(
  //       {
  //         data: res.data.histories.data
  //       },
  //       () => {
  //         this.onFetchData();
  //       }
  //     );
  //   }
  // };

  onFetchData() {
    let dataFetch = [];
    let dat = this.state.data;
    let data = dat.reverse();
    data.map((data, key) => {
      dataFetch.push([
        moment(data.created_at).format("YYYY-MM-DD"),
        data.examinations[0] ? data.examinations[0].sistole : '',
        data.examinations[0] ? data.examinations[0].diastole : '',
        data.examinations[0] ? data.examinations[0].pulse : '',
        parseInt(data.examinations[0] ? data.examinations[0].respiration : ''),
        data.examinations[0] ? data.examinations[0].temperature : ''
      ]);
    });
    this.setState({ dataFetch });
    Promise.all([dataFetch, schemaFetch]).then(res => {
      const data = res[0];
      const schema = res[1];
      const fusionTable = new FusionCharts.DataStore().createDataTable(
        data,
        schema
      );
      const timeseriesDs = Object.assign({}, this.state.timeseriesDs);
      timeseriesDs.dataSource.data = fusionTable;
      this.setState({
        timeseriesDs
      });
    });
  }

  render() {
    return (
      <div>
        {this.state.timeseriesDs.dataSource.data ? (
          <ReactFC {...this.state.timeseriesDs} />
        ) : (
            "loading"
          )}
      </div>
    );
  }
}
